'use strict';

import Component from 'generic.basecomponent';
import $ from 'jquery';
import template from '../html/jg-donations.hbs';
import templateEmpty from '../html/jg-donations-empty.hbs';
import moment from 'moment';

export default class JgDonations extends Component {
    constructor(el) {
        super(el);
        this.$container = $(this.container);
        this.init();
    }

    init() {
        this.baseURL = window.location.protocol + "//" + window.location.host;
        this.nodeId = this.$container.data('node-id');
        this.requestedPage = 1;

        if (!this.nodeId) {
            this.$container.addClass('js-init-errors');
            return false;
        }

        this.initLoadMore();
        this.loadData();
    }

    initLoadMore() {
        this.loadMoreBtn = document.querySelector(".js-jg-donations-load-more");
        this.loadMoreBtn.addEventListener("click", this.loadMore.bind(this));
    }

    loadMore() {
        this.requestedPage++;
        this.loadData();
    }

    loadData() {
        this.$container.addClass('is-loading');
        console.log(`${this.baseURL}/api/donation/Get?page=${this.requestedPage}&nodeId=${this.nodeId}`);
        const request = this.getRequest(`${this.baseURL}/api/donation/Get?page=${this.requestedPage}&nodeId=${this.nodeId}`);
        request.then((response) => {
            response.Next ? this.loadMoreBtn.classList.remove("is-hidden") : this.loadMoreBtn.classList.add("is-hidden");
            this.renderDonations(this.getPreparedDonations(response.Donations));
        }, (error) => {
            this.renderError(error);
        }).then(() => {
            this.$container.removeClass('is-loading');
        });
    }

    renderDonations(donations) {
        if (donations.length > 0) {
            let content = template({donations});
            this.$container.append(content);
        } else {
            this.renderEmpty();
        }
        this.loadMoreBtn.classList.remove("is-loading");
        this.loadMoreBtn.classList.remove("spinner--faded");
    }

    renderEmpty() {
        this.$container.html(templateEmpty({}));
    }

    renderError(error) {
        console.log(error);
        this.$container.html(`
            <div class="jg-error__container">
                <span class="jg-error">Sorry, we were unable to retrieve data. Please try again later.</span>
            </div>
        `);
    }

    getPreparedDonations(donations) {
        return donations.map(item => {
            let amount = parseFloat(item.Amount).toFixed(2);
            let giftAmount = item.GiftAidAmount !== undefined ? parseFloat(item.GiftAidAmount).toFixed(2) : 0;

            let dateString = null;
            let date = Date.parse(item.Date);
            date = parseInt(date);
            if (!isNaN(date)) {
                dateString = moment(date).format('DD MMM YYYY');
            }

            return {
                name: item.Donator || 'Anonymous',
                hasAmount: amount > 0,
                amount: amount,
                hasGift: giftAmount > 0,
                giftAmount: giftAmount,
                currencySign: "£",
                hasDate: dateString !== null,
                date: dateString,
                message: item.Comment
            }
        });
    }

    getRequest(url) {
        this.loadMoreBtn.classList.add("is-loading");
        this.loadMoreBtn.classList.add("spinner--faded");
        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                contentType: 'application/json'
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }


}



// WEBPACK FOOTER //
// ./app/components/jg-donations/js/generic.jg-donations.js